import Axios from "../../configs/axios.config";

// Get audit logs for a specific model and model_id
export const getAuditLogs = (params) =>
  Axios.get(`/audit-log`, { params }).then((response) => response.data);

// Get salary-specific audit logs for an employee
export const getSalaryAuditLogs = (employeeId, params = {}) =>
  Axios.get(`/audit-log`, {
    params: {
      model: "SalaryAssignment",
      model_id: employeeId,
      ...params,
    },
  }).then((response) => response.data);
